import React from "react";

const gstData = [
  { id: "01.", state: "Andaman and Nicobar Islands", url: "www.andaman.nic.in" },
  { id: "02.", state: "Andhra Pradesh", url: "www.apct.gov.in" },
  { id: "03.", state: "Arunachal Pradesh", url: "www.aruntax.nic.in" },
  { id: "04.", state: "Assam", url: "www.tax.assam.gov.in" },
  { id: "05.", state: "Bihar", url: "www.biharcommercialtax.gov.in" },
  { id: "06.", state: "Chandigarh", url: "www.etdut.gov.in" },
  { id: "07.", state: "Chhattisgarh", url: "www.comtax.cg.nic.in" },
  { id: "08.", state: "Dadra and Nagar Haveli", url: "www.dnhctd.gov.in" },
  { id: "09.", state: "Daman and Diu", url: "https://swp.dddgov.in/vat-and-gst-dnhdd" },
  { id: "10.", state: "Delhi", url: "www.dvat.gov.in" },
  { id: "11.", state: "Goa", url: "www.goagst.gov.in/comtax_start.html" },
  { id: "12.", state: "Gujarat", url: "www.commercialtax.gujarat.gov.in" },
  { id: "13.", state: "Haryana", url: "www.haryanatax.com" },
  { id: "14.", state: "Himachal Pradesh", url: "https://www.hptax.gov.in" },
  { id: "15.", state: "Jammu and Kashmir", url: "www.jkcomtax.gov.in" },
  { id: "16.", state: "Jharkhand", url: "www.jharkhandcomtax.gov.in" },
  { id: "17.", state: "Karnataka", url: "www.ctax.kar.nic.in" },
  { id: "18.", state: "Kerala", url: "www.keralataxes.gov.in" },
  { id: "19.", state: "Lakshadweep", url: "www.lakshadweep.nic.in" },
  { id: "20.", state: "Madhya Pradesh", url: "www.gstcouncil.gov.in/states/madhya-pradesh" },
  { id: "21.", state: "Maharashtra", url: "www.mahavat.gov.in" },
  { id: "22.", state: "Manipur", url: "www.manipurvat.gov.in" },
  { id: "23.", state: "Meghalaya", url: "www.megvat.gov.in" },
  { id: "24.", state: "Mizoram", url: "www.zotax.nic.in" },
  { id: "25.", state: "Nagaland", url: "www.nagalandtax.nic.in" },
  { id: "26.", state: "Orissa", url: "www.odishatax.gov.in" },
  { id: "27.", state: "Puducherry", url: "www.gst.puducherry.gov.in" },
  { id: "28.", state: "Punjab", url: "www.pextax.com" },
  { id: "29.", state: "Rajasthan", url: "www.rajtax.gov.in" },
  { id: "30.", state: "Sikkim", url: "www.sikkimtax.gov.in" },
  { id: "31.", state: "Tamil Nadu", url: "www.tnvat.gov.in" },
  { id: "32.", state: "Tripura", url: "www.tripurataxes.nic.in" },
  { id: "33.", state: "Telangana", url: "www.tgct.gov.in/tgportal/" },
  { id: "34.", state: "Uttarakhand", url: "www.comtax.uk.gov.in" },
  { id: "35.", state: "Uttar Pradesh", url: "www.comtax.up.nic.in" },
  { id: "36.", state: "West Bengal", url: "www.wbcomtax.nic.in" },
];

export default function GstVat() {
  return (
    <div className="px-3 sm:px-5" style={{ padding: "40px 20px", fontFamily: "Arial, sans-serif" }}>
      
      <div className="max-w-[1100px] mx-auto" style={{ maxWidth: "1100px", margin: "0 auto" }}>
        
        {/* Header */}
        <div 
          className="px-4 py-4 sm:px-5 sm:py-5"
          style={{
            background: "#f0f7ff",
            border: "1px solid #d1d5db",
            borderRadius: "8px",
            padding: "20px",
            textAlign: "center",
            marginBottom: "25px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
          }}
        >
          <h2 style={{ color: "#1a3c6e", margin: 0, fontSize: "22px", fontWeight: "700", textTransform: "uppercase" }}>
            Goods and Service Tax Website of Indian States
          </h2>
        </div>

        {/* TABLE CONTAINER (MOBILE FIX) */}
        <div 
          className="overflow-x-auto"
          style={{ border: "1px solid #e5e7eb", borderRadius: "8px", overflow: "hidden" }}
        >
          <table 
            className="min-w-[600px]"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#fff",
              textAlign: "left"
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f3f4f6" }}>
                <th style={styles.th}>S. No.</th>
                <th style={styles.th}>State</th>
                <th style={{ ...styles.th, borderRight: "none" }}>Website</th>
              </tr>
            </thead>

            <tbody>
              {gstData.map((item, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #e5e7eb" }}>
                  
                  <td className="whitespace-nowrap" style={{ ...styles.td, width: "70px" }}>
                    {item.id}
                  </td>

                  <td className="whitespace-nowrap sm:whitespace-normal" style={{ ...styles.td, width: "300px" }}>
                    {item.state}
                  </td>

                  <td className="whitespace-nowrap" style={{ ...styles.td, borderRight: "none" }}>
                    <a 
                      href={item.url.startsWith('http') ? item.url : `https://${item.url}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="break-all"
                      style={{ color: "#1d4ed8", textDecoration: "none" }}
                    >
                      {item.url}
                    </a>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

const styles = {
  th: {
    padding: "15px",
    fontSize: "15px",
    fontWeight: "700",
    color: "#374151",
    borderBottom: "1px solid #e5e7eb",
    borderRight: "1px solid #e5e7eb",
    backgroundColor: "#f9fafb"
  },
  td: {
    padding: "12px 15px",
    fontSize: "14px",
    color: "#4b5563",
    borderRight: "1px solid #e5e7eb"
  }
};